import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { resetStates } from "../../../actions/Common";
import Notification, { DeactivateNotificationPayload, EditNotification } from "../components/Notification";
import { getNotificationTypeList } from "../../../actions/Master";
import { deactivateNotification, postNotificationList, updateNotification } from "../../../actions/AdminActions";
import { getListResult } from "../../../utils";

const mapStateToProps = ({
  notificationListState,
  notificationTypeState,
  loggedInUserState,
  updateNotificationState,
  deactivateNotificationState,
  notificationsState
}: ApplicationState) => ({
  notificationListState: getNotifications(notificationListState),
  notificationType: getListResult(notificationTypeState.response),
  loggedInUser: loggedInUserState.response,
  updateNotificationState: updateNotificationState.response,
  deactivateNotificationState: deactivateNotificationState.response,
  notificationsState
});

const getNotifications = (notificationTypeState: any) => {
  return notificationTypeState.response
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    },
    getNotificationTypeList: () => {
      dispatch(getNotificationTypeList());
    },
    postNotificationList: (payload: any) => {
      dispatch(postNotificationList(payload))
    },
    updateNotification: (payload: EditNotification) => {
      dispatch(updateNotification(payload))
    },
    deactivateNotification: (payload: DeactivateNotificationPayload) => {
      dispatch(deactivateNotification(payload))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
